export const imagesAbout = [
    { imgPath: '/pimages/img_axl/02_about_carousel/a01.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a02.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a03.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a04.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a05.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a06.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a07.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a08.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a09.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a10.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a11.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a12.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a13.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a14.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a15.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a16.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a17.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a18.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a19.jpg', label: '' },
    { imgPath: '/pimages/img_axl/02_about_carousel/a20.jpg', label: '' },
  ];